/* Custom Reaven — comportamento del popup newsletter.
   - compare dopo `data-delay` secondi, al massimo una volta ogni `data-frequency`
     giorni (localStorage); mai per chi si e' gia' iscritto
   - `reaven:newsletter-popup:open` lo apre a comando (es. "Avvisami al Lancio"),
     ignorando lo snooze
   - nell'editor tema si apre selezionando la sezione, mai da solo
   - su telefono e' un pannello in basso non modale: non sposta il focus (niente
     tastiera aperta da sola) e si chiude scendendo
   - aspetta che il banner dei cookie (iubenda) sia chiuso: starebbe sopra al pannello
   - `#newsletter` nell'indirizzo lo apre subito, per rivederlo senza aspettare */
(function () {
  if (window.__reavenNewsletterPopup) return;
  window.__reavenNewsletterPopup = true;

  var KEY_SNOOZE = 'reaven:nlp:snooze';
  var KEY_DONE = 'reaven:nlp:done';

  function storageGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function storageSet(key, value) {
    try { localStorage.setItem(key, value); } catch (e) { /* navigazione privata: pazienza */ }
  }

  function init() {
    var popup = document.querySelector('.newsletter-popup');
    if (!popup) return;

    var designMode = popup.hasAttribute('data-design-mode');
    var frequencyDays = parseInt(popup.dataset.frequency, 10) || 15;
    var delaySeconds = parseInt(popup.dataset.delay, 10);
    if (isNaN(delaySeconds)) delaySeconds = 5;
    var lastFocus = null;
    var panel = popup.querySelector('.newsletter-popup__panel');
    var mqMobile = window.matchMedia('(max-width: 749px)');
    var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function open() {
      if (!popup.hidden) return;
      lastFocus = document.activeElement;
      popup.classList.remove('is-closing');
      popup.hidden = false;
      document.body.classList.add('newsletter-popup-open');
      var mobile = mqMobile.matches;
      if (panel) panel.setAttribute('aria-modal', mobile ? 'false' : 'true');
      var error = popup.querySelector('[data-nlp-error]');
      var success = popup.querySelector('[data-nlp-success]');
      var input = popup.querySelector('.newsletter-popup__input');
      var target = null;
      if (error) target = input;
      else if (success) target = success;
      else if (!mobile) target = input || popup.querySelector('.newsletter-popup__close');
      if (target && target.focus) target.focus({ preventScroll: true });
    }

    function close(snooze) {
      if (popup.hidden || popup.classList.contains('is-closing')) return;
      var focusDentro = popup.contains(document.activeElement);
      document.body.classList.remove('newsletter-popup-open');
      if (snooze && !designMode) {
        storageSet(KEY_SNOOZE, String(Date.now() + frequencyDays * 864e5));
      }
      function finish() {
        popup.classList.remove('is-closing');
        popup.hidden = true;
      }
      if (mqMobile.matches && !mqReduce.matches) {
        popup.classList.add('is-closing');
        window.setTimeout(finish, 260);
      } else {
        finish();
      }
      if (focusDentro && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    // banner dei cookie ancora aperto? (fisso in basso, sopra a tutto)
    function cookieBannerAperto() {
      var banner = document.getElementById('iubenda-cs-banner');
      if (!banner) return false;
      var stile = window.getComputedStyle(banner);
      if (stile.display === 'none' || stile.visibility === 'hidden') return false;
      return banner.getBoundingClientRect().height > 0;
    }

    function openQuandoLibero() {
      if (!cookieBannerAperto()) {
        open();
        return;
      }
      var attesa = window.setInterval(function () {
        if (cookieBannerAperto()) return;
        window.clearInterval(attesa);
        window.setTimeout(open, 1500);
      }, 800);
    }

    function caricaFoto() {
      var img = popup.querySelector('.newsletter-popup__image');
      if (img) img.loading = 'eager';
    }

    popup.addEventListener('click', function (event) {
      if (event.target.closest('[data-nlp-close]')) close(true);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !popup.hidden) close(true);
    });

    // apertura a comando (bottone "Avvisami al Lancio" del sistema drop)
    document.addEventListener('reaven:newsletter-popup:open', function () {
      open();
    });

    // editor tema: si apre selezionando la sezione
    document.addEventListener('shopify:section:select', function (event) {
      if (popup.closest('.shopify-section') === event.target) open();
    });
    document.addEventListener('shopify:section:deselect', function (event) {
      if (popup.closest('.shopify-section') === event.target) close(false);
    });

    // iscrizione appena inviata: riapri per mostrare la conferma e non riproporre mai piu'
    if (popup.querySelector('[data-nlp-success]')) {
      storageSet(KEY_DONE, '1');
      open();
      return;
    }

    // errore nel form (email non valida): riapri per mostrarlo
    if (popup.querySelector('[data-nlp-error]')) {
      open();
      return;
    }

    if (designMode) return;

    // #newsletter nell'indirizzo: aperto subito, anche se gia' chiuso di recente
    if (/(^|&)newsletter(&|$)/.test(window.location.hash.slice(1))) {
      caricaFoto();
      openQuandoLibero();
      return;
    }

    if (storageGet(KEY_DONE) === '1') return;
    var snoozedUntil = parseInt(storageGet(KEY_SNOOZE), 10);
    if (!isNaN(snoozedUntil) && snoozedUntil > Date.now()) return;

    caricaFoto();
    window.setTimeout(openQuandoLibero, delaySeconds * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
